import CSModel from '../../../models/secure/CSModel';

// Payload required: { userId: value, sessionId: value, orderNo: value, request: value }
const updateService = async (context, payload) => {
    let csModel = new CSModel();
    return csModel.updateService(payload).then(res => {
        let commitTarget = (res.data && res.data.status == CSModel.STATUS_SUCCESS) ? 'SET_UPDATE_SERVICE' : 'CLEAR_UPDATE_SERVICE';
        context.commit(commitTarget, res.data.records);
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            description: err + " - Failed to connect to server"
        };
    });
}

const clearStates = (context) => {
    context.commit('CLEAR_STATES');
};

export {
    updateService,
    clearStates
}
